/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ListTrainField {
    ALERT_STATUS = 'alert_status',
    TRAIN_TYPE = 'train_type',
    DISTANCE = 'distance',
}
